const UnbeatableOfferUnconnectedIcon = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.33334 4.33366C4.33334 2.30861 5.97496 0.666992 8.00001 0.666992C10.0251 0.666992 11.6667 2.30861 11.6667 4.33366V6.00033C11.6667 6.36851 11.3682 6.66699 11 6.66699C10.6318 6.66699 10.3333 6.36851 10.3333 6.00033V4.33366C10.3333 3.04499 9.28868 2.00033 8.00001 2.00033C6.71134 2.00033 5.66668 3.04499 5.66668 4.33366V6.00033C5.66668 6.36851 5.3682 6.66699 5.00001 6.66699C4.63182 6.66699 4.33334 6.36851 4.33334 6.00033V4.33366Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.99999 5.5C2.9874 5.5 2.16656 6.32091 2.16666 7.33353L2.16721 13.3335C2.1673 14.3459 2.98809 15.1667 4.00054 15.1667H11.9999C13.0124 15.1667 13.8332 14.3459 13.8332 13.3333V7.33333C13.8332 6.32081 13.0124 5.5 11.9999 5.5H3.99999ZM8.66666 9.66667C8.66666 9.29847 8.36819 9 7.99999 9C7.63179 9 7.33332 9.29847 7.33332 9.66667V11C7.33332 11.3682 7.63179 11.6667 7.99999 11.6667C8.36819 11.6667 8.66666 11.3682 8.66666 11V9.66667Z"
			fill="currentColor"
		/>
	</svg>
);

export default UnbeatableOfferUnconnectedIcon;
